module.exports = __webpack_public_path__ + "static/media/toilet270.8b3e77fc.png";